import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ThoughtCard {
  text: string[];
  bgColor: string;
  buttonBg: string;
}

export function ThoughtCards() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    setTimeout(() => {
      const input = document.querySelector('#url-input');
      if (input) {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        input.classList.add('pulse-animation');
        setTimeout(() => {
          input.classList.remove('pulse-animation');
        }, 2000);
      }
    }, 100);
  };

  const thoughts: ThoughtCard[] = [
    {
      text: [
        "Your product only works with free traffic?",
        "It's not enough, but free traffic is limited."
      ],
      bgColor: "bg-gray-50",
      buttonBg: "bg-black"
    },
    {
      text: [
        "Is your competition growing and you're dealing with everything yourself?",
        "Get busy with ideas, not getting a client."
      ],
      bgColor: "bg-[#B4FF8C]",
      buttonBg: "bg-black"
    },
    {
      text: [
        "Tired of coming up with headlines?",
        "Take care of the code, and we'll take care of the text."
      ],
      bgColor: "bg-black",
      buttonBg: "bg-white"
    },
    {
      text: [
        "Also think your site is worthy of more attention?",
        "Let's rock your sales already."
      ],
      bgColor: "bg-gray-50",
      buttonBg: "bg-black"
    }
  ];

  return (
    <section className="py-16 px-4">
      <h2 className="text-3xl font-bold text-center mb-12">
        Are these thoughts familiar to you?
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {thoughts.map((thought, index) => (
          <div
            key={index}
            className={`${thought.bgColor} p-8 rounded-[32px] flex flex-col justify-between min-h-[280px]`}
          >
            <div className="space-y-2">
              {thought.text.map((line, i) => (
                <div
                  key={i}
                  className="bg-[#B4FF8C] px-4 py-2 rounded-lg inline-block"
                >
                  <p className={`text-lg font-medium ${thought.bgColor === 'bg-black' ? 'text-black' : 'text-black'}`}>
                    {line}
                  </p>
                </div>
              ))}
            </div>
            <button 
              onClick={handleClick}
              className={`${thought.buttonBg} text-${thought.bgColor === 'bg-black' ? 'black' : 'white'} flex items-center gap-2 px-4 py-2 rounded-full mt-6 w-fit hover:opacity-90 transition-opacity`}
            >
              <span>Yeah, that's me</span>
              <ArrowUpRight className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}